import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Wrapper,
  Title,
  Information,
  Closure,
  ClosureInfo,
} from './styled';
import { DayType } from '@app/src/common/datePicker/types/Day';
import { ABREV_MONTHS, getStateConfig } from '@app/src/common/datePicker/state/calendar/constants';
import { DateSelectedType } from '@app/src/common/datePicker/types/Date';
import { addDateSelected, deleteDateSelected } from '@app/src/common/datePicker/state/calendar/actions';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { SectionDateSelected } from '@app/src/common/datePicker';
import {
  TypePublicationModel,
  clearExtracharge,
  FormActions,
  setPrintAllByChannel,
  // setExtracharge
} from '@app/src/views/StepTwo/channelPublication';
import { setPriceTotalByChannel } from '@app/src/views/StepOne/form/state/priceTotal/actions';

interface Props {
  handleClickNext: Function;
  handleClickBack: Function;
  title: string;
  priceAside: number;
  open: boolean;
  categoryId?: number;
}

export const DatePicker: React.FC<Props> = ({
  handleClickNext,
  handleClickBack,
  categoryId
}) => {

  const dispatch = useDispatch();
  const dateSelected = useSelector(state => state.calendar);
  const currentChannel: TypePublicationModel = useSelector(state => state.typePublication.selected);
  const channelId = currentChannel && currentChannel.id;
  const newspaperId = currentChannel && currentChannel.newspaperId;
  let currentDateSelected = dateSelected[getStateConfig[channelId]];
  const isButtonNextDisabled: boolean = currentDateSelected && currentDateSelected.length === 0;
  const categoryTheme = CATEGORIES[CATEGORY[categoryId]];
  const priceTotalData = useSelector(state => state.priceTotal.data);
  const extracharges = useSelector(state => state.extracharge.data[channelId]);
  const extraWords = useSelector(state => state.print.general.extraWords);
  const [priceIgvExtracharge, setPriceIgvExtracharge] = useState(0);
  const [priceExtracharge, setPriceExtracharge] = useState(0);

  useEffect(() => {
    const arrDetails = hydrateSelecteds();
    dispatch(setPrintAllByChannel(String(channelId), arrDetails));
  }, [currentDateSelected]);

  // useEffect(() => {
  //   if (printsByChannel&& printsByChannel[channelId]) {
  //     dispatch(addDateSelectedAll(printsByChannel[channelId], channelId))
  //   }
  // }, [printsByChannel, currentChannel]);

  const hydrateSelecteds = () => {
    const arr = currentDateSelected && currentDateSelected.map(item => ({
      dayMonth: item.dayMonth,
      fullDate: item.fullDate,
      month: item.month,
      year: item.year,
      publicationId: currentChannel && currentChannel.id,
      newspaperId: currentChannel && currentChannel.newspaperId,
      packageId: currentChannel && currentChannel.packageId,
      price: currentChannel && currentChannel.price,
      priceIgv: currentChannel && currentChannel.priceIgv,
      datePrint: `${item.year}-${getZeroFormatDate(item.month + 1)}-${getZeroFormatDate(item.dayMonth)}`,
      dateFormat: `${item.fullDate} ${item.year}`
    }))
    return arr;
  };

  const getZeroFormatDate = (date: number) => {
    if (date <= 9) {
      return `0${date}`;
    }
    return date;
  };

  useEffect(() => {
    if (priceTotalData && Object.keys(priceTotalData).length > 0) {
      let currentPrice = 0;
      Object.keys(priceTotalData).map((id) => {
        currentPrice = currentPrice + priceTotalData[id].priceIgv;
      });
    }
  }, [priceTotalData]);

  useEffect(() => {
    if (extracharges && extracharges.data && extracharges.data.length > 0) {
      let price = 0;
      let priceIgv = 0;
      extracharges.data.map((item) => {
        if (item.checked === true) {
          if (item.alias === 'palabra-extra') {
            price = price + (item.price * extraWords);
            priceIgv = priceIgv + (item.priceIgv * extraWords);
          } else {
            price = price + item.price;
            priceIgv = priceIgv + item.priceIgv;
          }
        }
      });
      setPriceExtracharge(price);
      setPriceIgvExtracharge(priceIgv);
    }
  }, [extracharges]);

  useEffect(() => {
    if (channelId) {
      dispatch(setPriceTotalByChannel(currentChannel.id,
        {
          price: ((currentChannel.price) + priceExtracharge) * (currentDateSelected && currentDateSelected.length),
          priceIgv: (currentChannel.priceIgv + priceIgvExtracharge) * (currentDateSelected && currentDateSelected.length)
        }));
    }
  }, [priceIgvExtracharge, currentDateSelected, priceExtracharge, currentChannel]);

  const handleAddDay = useCallback(
    (date: DateSelectedType) => {
      dispatch(addDateSelected(date, channelId));
    },
    [dispatch]
  );

  const handleDeleteDay = useCallback(
    (date: DateSelectedType) => {
      dispatch(deleteDateSelected(date, channelId));
      if (currentDateSelected && currentDateSelected.length === 0) {
        dispatch(clearExtracharge(channelId));
      }
    },
    [dispatch, currentDateSelected]
  );

  const handleClickDay = (day: DayType) => {
    const isSameDate = currentDateSelected && currentDateSelected.filter(e => e && day && e.dayMonth === day.dayMonth && e.month === day.month);
    if (!(isSameDate && isSameDate.length)) {
      const fullDate: string = `${day.dayName}. ${day.dayMonth} ${ABREV_MONTHS[day.month]}.`
      const selected = {
        id: day.id,
        dayMonth: day.dayMonth,
        month: day.month,
        year: day.year,
        fullDate,
        stateMonth: day.stateMonth
      }
      handleAddDay(selected);
    }
    const datePicked = dateIsSelected(day);
    if (datePicked) {
      handleDeleteDay(datePicked);
    }
  };

  const dateIsSelected = (day: DayType) => {
    return currentDateSelected && currentDateSelected.filter(e => e && day && e.dayMonth === day.dayMonth && e.month === day.month && e.year === day.year)[0];
  };

  const convertToArray = (text: string) => text.split(',');

  const getDataFromCalendar = () => ({
    id: channelId,
    newspapper: newspaperId,
    packageId: currentChannel && currentChannel.packageId,
    printDate: currentDateSelected
  });

  const propClickNext = () => {
    handleClickNext && handleClickNext(getDataFromCalendar());
  };

  const propClickBack = () => {
    handleClickBack && handleClickBack(getDataFromCalendar());
  };

  return (
    <React.Fragment>
      <Wrapper>
        <Title>¿Cuándo quieres publicar?</Title>
        <SectionDateSelected
          currentDateSelected={currentDateSelected}
          categoryTheme={categoryTheme}
          handleClickDeleteDay={handleDeleteDay}
          handleClickDay={handleClickDay}
        />
        <Information>
          <Closure>Cierre de publicación:</Closure>
          {
            currentChannel && currentChannel.description && convertToArray(currentChannel.description).map((date, index) => (
              <ClosureInfo key={index}>- {date}</ClosureInfo>
            ))
          }
        </Information>
      </Wrapper>
      <FormActions
        textButtonBack={'Datos del aviso'}
        handleButtonBack={propClickBack}
        handleButtonNext={propClickNext}
        disabledButtonNext={isButtonNextDisabled} />
    </React.Fragment>
  )
};
